import { NPagination } from '@innersource-nn/novoui-react';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PaginationComponentProps } from 'types/Pagination';

const Pagination: React.FC<PaginationComponentProps> = ({
    items,
    filter,
    setFilter,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [itemsPerPageOptions, setItemsPerPageOptions] = useState([
        { key: 10, label: '10', value: 10 },
        { key: 25, label: '25', value: 25 },
        { key: 100, label: '100', value: 100 },
    ]);

    const [count, setCount] = useState<number>(
        Math.ceil(items.count / filter?.pageSize),
    );

    const onUpdatePage = async (page: number) => {
        if (page <= items.pages && page !== items.page) {
            const searchParams = new URLSearchParams(location.search);
            searchParams.set('page', page.toString());
            navigate({
                pathname: location.pathname,
                search: searchParams.toString(),
            });
            await setFilter({ ...filter, page });
        }
    };

    const onUpdateItemsPerPage = (number: number) => {
        setFilter({ ...filter, pageSize: number, page: 1 }); // Reset to first page when changing rows per page
    };
    useEffect(() => {
        if (
            !!filter?.pageSize &&
            [10, 25, 100].indexOf(filter.pageSize) === -1
        ) {
            // Create a new array with the original options and the new option
            const updatedRowsPerPageOptions = [
                ...itemsPerPageOptions,
                {
                    key: filter.pageSize,
                    label: filter.pageSize.toString(),
                    value: filter.pageSize,
                },
            ];

            // Sort the options based on value
            updatedRowsPerPageOptions.sort((a, b) => a.value - b.value);
            // Update the rowsPerPageOptions array
            setItemsPerPageOptions(updatedRowsPerPageOptions);
        }
    }, [filter?.pageSize]);
    useEffect(() => {
        if (
            !!filter?.pageSize &&
            [10, 25, 100].indexOf(filter.pageSize) === -1
        ) {
            // Create a new array with the original options and the new option
            const updatedRowsPerPageOptions = [
                ...itemsPerPageOptions,
                {
                    key: filter.pageSize,
                    label: filter.pageSize.toString(),
                    value: filter.pageSize,
                },
            ];

            // Sort the options based on value
            updatedRowsPerPageOptions.sort((a, b) => a.value - b.value);

            // Update the rowsPerPageOptions array
            setItemsPerPageOptions(updatedRowsPerPageOptions);
        }
    }, [filter?.pageSize]);

    useEffect(() => {
        setCount(Math.ceil(items.count / filter?.pageSize));
    }, [filter?.pageSize, items.count]);

    return (
        <div className="flex justify-end mt-16">
            <NPagination
                page={filter.page}
                count={count}
                shape="rounded"
                size="small"
                color="primary"
                variant="text"
                itemsPerPage={filter.pageSize}
                itemsPerPageOptions={itemsPerPageOptions}
                onUpdatePage={onUpdatePage}
                onUpdateItemsPerPage={onUpdateItemsPerPage}
                hidePrevNext={true}
            />
        </div>
    );
};

export default Pagination;
